import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from '../Timeline.module.scss'

const cx = cn.bind(s)

export interface ITimelineItemProps {
	title?: React.ReactNode
	active?: boolean
	lineActive?: boolean
	children?: React.ReactNode
	onClick?: () => void
}

const TimelineItem: FC<ITimelineItemProps> = ({children, active, lineActive, onClick}) => {
	return (
		<div
			className={cx('item', active && 'item--active', lineActive && 'item--line-active')}
			{...(onClick
				? {
						onClick,
						onKeyDown: onClick,
						role: 'button',
						tabIndex: 0,
				  }
				: {})}>
			<div className={cx('bullet', active && 'bullet--active')} />
			<div className={cx('item__body')}>{children}</div>
		</div>
	)
}

export default TimelineItem
